import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home.jsx";
import Login from "./pages/Login.jsx";
import Register from "./pages/Register.jsx";
import Payment from "./pages/Payment.jsx";
import Listings from "./pages/Listings.jsx";
import Portfolio from "./pages/Portfolio.jsx";
import Contracts from "./pages/Contracts.jsx";
import Landlords from "./pages/Landlords.jsx";
import Tenants from "./pages/Tenants.jsx";
import Bills from "./pages/Bills.jsx";
import Condominiums from "./pages/Condominiums.jsx";
import PropertyShares from "./pages/PropertyShares.jsx";
import Header from "./components/Header.jsx";
import Footer from "./components/Footer.jsx";

export default function App({ keycloak }) {
  return (
    <div className="app-shell">
      <Header keycloak={keycloak} />
      <main className="app-main">
        <Routes>
          <Route path="/" element={<Home keycloak={keycloak} />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/payment" element={<Payment />} />
          <Route path="/listings" element={<Listings />} />
          <Route path="/portfolio" element={<Portfolio keycloak={keycloak} />} />
          <Route path="/contracts" element={<Contracts keycloak={keycloak} />} />
          <Route path="/landlords" element={<Landlords keycloak={keycloak} />} />
          <Route path="/tenants" element={<Tenants keycloak={keycloak} />} />
          <Route path="/bills" element={<Bills keycloak={keycloak} />} />
          <Route path="/condominiums" element={<Condominiums keycloak={keycloak} />} />
          <Route path="/shares" element={<PropertyShares keycloak={keycloak} />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}
